import { jsx as _jsx } from "react/jsx-runtime";
import { tableRowClasses as muiTableRowClasses } from '@mui/material';
import { forwardRef } from 'react';
import { TableRowStyled } from './TableRow.styled';
/**
 * **Global Parts** `TableRow` component.
 */
const TableRow = forwardRef((props, ref) => {
    return _jsx(TableRowStyled, { ref: ref, ...props });
});
export { TableRow, muiTableRowClasses as tableRowClasses };
